<div class="">
  <div (click)="$event.stopPropagation(); togglePanel()" class="cursor-pointer">
    <ng-content select="[expansion-panel-header]"></ng-content>
  </div>
  <div
    class="expansion-panel-content"
    [ngStyle]="{ 'max-height': isOpen ? 'fit-content' : '0px' }"
  >
    <!-- max-height: fit-content -->
    <div #contentWrapper>
      <ng-content select="[expansion-panel-content]"></ng-content>
    </div>
  </div>
</div>
